import React from 'react'

export default function Phone({oym,phone}) {
    let phoneObject=oym.objectRef(phone);
    if (phoneObject.number==null){
        return null;
    }
    let phoneNumberString=phoneObject.number;
    if ((phoneObject.type!=null&&phoneObject.type!="UNSPECIFIED") || phoneObject.ownerName!=null){
        phoneNumberString+=" (";
        if (phoneObject.type!=null&&phoneObject.type!="UNSPECIFIED"){
            phoneNumberString+=phoneObject.type;
            if (phoneObject.ownerName!=null){
                phoneNumberString+=" ";
            }
        } 
        if (phoneObject.ownerName!=null) {
            phoneNumberString+="Owner:";
            phoneNumberString+=phoneObject.ownerName;
        }
        phoneNumberString+=")";
    }
    return (
        <>
         {phoneNumberString}&nbsp;
        </>
    )
}
